//  Componente per visualizzazione del messaggio di benvenuto
//  Si aspetta una props src contenente [email], da sostituire con email di subscriber e circondare con tag strong
import React from 'react';
import {PropTypes} from 'prop-types';

const WelcomeMessage = (props) => {
  //
  const tokens = [];

  const regexMatch = props.src.trim().split(/(\[email\])/);

  regexMatch.forEach((token) => {
    if(token == "[email]") {
      tokens.push({isEmail: true, content: props.email});
    } else {
      tokens.push({isEmail: false, content: token});
    }
  }); 

  return(
    <React.Fragment>
    {tokens.map((o, idx) => {
      if(o.isEmail) return (<strong key={idx}>{o.content}</strong>);
      else return (<React.Fragment key={idx}>{o.content}</React.Fragment>);
    })}
    </React.Fragment>
  );
};

WelcomeMessage.defaultProps = {
  src: '',
  email: ''
};

WelcomeMessage.propTypes = {
  src: PropTypes.string,
  email: PropTypes.string
};


export default WelcomeMessage;

/*

const regexMatch = RegexAPI.containsEmail().exec(intro.innerHTML);
      if(regexMatch && regexMatch.index && regexMatch[0]) {
        const range = document.createRange();
        range.setStart(intro.firstChild, regexMatch.index);
        range.setEnd(intro.firstChild, regexMatch.index + regexMatch[0].length);

        const surrounding = document.createElement("strong");
        range.surroundContents(surrounding);
      }

*/